import React, { useState, useEffect } from "react"
import {
  CardBody,
  Container,
  Row,
  Col,
  Card,
  Button,
  ListGroup,
  ListGroupItem,
  Badge,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { ToastContainer, toast } from "react-toastify"
import { useHistory } from "react-router-dom"
import { URLS } from "../../Url"
import axios from "axios"
import logo from "../../assets/images/logo.png"

function ViewAdvertisements() {
  const navigate = useHistory()
  const Advertisements = sessionStorage.getItem("Advertisementid")

  const [advertisement, setAdvertisement] = useState({
    name: "",
    storeName: "",
    advcategoryName: "",
    priority: "",
    advpriority: "",
    type: "",
    cities: [],
    image: "",
    video: "",
    status: "",
    advprice: "",
    advtype: "",
    productName: "",
  })

  const [mediaUrl, setMediaUrl] = useState("")
  const [citiesList, setCitiesList] = useState([])
  const [advPayment, setAdvPayment] = useState({
    transactionId: "",
    amount: "",
    date: "",
    time: "",
    paymentStatus: "",
  })

  const getAuthToken = () => {
    try {
      const authUser = localStorage.getItem("authUser")
      if (!authUser) return null
      const tokenJson = JSON.parse(authUser)
      return tokenJson?.token || null
    } catch (error) {
      console.error("Error parsing auth token:", error)
      return null
    }
  }

  const token = getAuthToken()
  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}")
  const vendorDetails = authUser?.vendor || {}

  useEffect(() => {
    getOneAdvertisementData()
  }, [])

  const getOneAdvertisementData = () => {
    const data = {
      id: Advertisements,
    }

    axios
      .post(URLS.GetOneAdvertisement, data, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(res => {
        const advertisementData = res?.data?.advertisement || {}
        setAdvertisement(advertisementData)

        // Set payment data with proper fallbacks
        const paymentData = advertisementData?.advpayments || {}
        setAdvPayment({
          transactionId: paymentData.transactionId || "-",
          amount: paymentData.amount || "-",
          date: paymentData.date || "-",
          time: paymentData.time || "-",
          paymentStatus: paymentData.paymentStatus || "-",
        })

        // Set media URL
        if (advertisementData.type === "image" && advertisementData.image) {
          setMediaUrl(URLS.Base + advertisementData.image)
        } else if (
          advertisementData.type === "video" &&
          advertisementData.video
        ) {
          setMediaUrl(URLS.Base + advertisementData.video)
        }

        // Set cities list
        if (Array.isArray(advertisementData.deliveryIdsNames)) {
          setCitiesList(advertisementData.deliveryIdsNames)
        }
      })
      .catch(error => {
        console.error("Error fetching advertisement data:", error)
        toast.error("Failed to load advertisement data")
      })
  }

  const renderMedia = () => {
    if (!mediaUrl) return <div className="text-muted">No media available</div>

    return advertisement.type === "image" ? (
      <img
        src={mediaUrl}
        alt="Advertisement"
        className="img-fluid rounded shadow-sm"
        style={{ maxHeight: "400px", objectFit: "contain" }}
      />
    ) : (
      <video
        controls
        className="w-100 rounded shadow-sm"
        style={{ maxHeight: "400px" }}
      >
        <source src={mediaUrl} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    )
  }

  const addBooking = () => {
    const totals = parseInt(advertisement.advprice) * 100
    const options = {
      key: "rzp_test_HJG5Rtuy8Xh2NB",
      amount: totals,
      currency: "INR",
      name: "Bizzmate",
      description: "Bizzmate Transaction",
      image: logo,
      handler: function (response) {
        const dataArrays = {
          advId: Advertisements,
          paymentStatus: "completed",
          transactionId: response.razorpay_payment_id,
          amount: advertisement.advprice,
          status: "active",
        }

        axios
          .post(URLS.AddAdvertisementPayment, dataArrays, {
            headers: { Authorization: `Bearer ${token}` },
          })
          .then(res => {
            if (res.status === 200) {
              toast.success(res.data.message)
              getOneAdvertisementData()
            }
          })
          .catch(error => {
            if (error.response?.status === 400) {
              toast.error(error.response.data.message)
            }
          })
      },
      prefill: {
        name: `${vendorDetails.firstName || ""} ${
          vendorDetails.lastName || ""
        }`.trim(),
        email: vendorDetails.email || "",
        contact: vendorDetails.sellerMobile || "",
      },
      theme: {
        color: "#00578E",
      },
    }

    const rzp1 = new window.Razorpay(options)
    rzp1.open()
  }

  const renderPaymentStatusBadge = () => {
    const status = advPayment.paymentStatus.toLowerCase()
    const colorMap = {
      completed: "success",
      pending: "warning",
      failed: "danger",
      active: "success",
      inactive: "secondary",
    }

    return (
      <b className={`text-${colorMap[status] || "primary"} text-capitalize`} >
        {status}
      </b>
    )
  }

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs
          title="Bizzmate Supplier"
          breadcrumbItem="View Advertisement"
        />

        <Card>
          <CardBody>
            <Row className="mb-2">
              <Col className="text-end">
                {advertisement.status == "inactive" && (
                  <Button onClick={addBooking} color="primary" className="me-2">
                    <i className="fas fa-credit-card me-2" size="sm"></i>
                    Make Payment
                  </Button>
                )}
                <Button onClick={() => navigate.goBack()} color="primary" size="sm">
                  <i className="fas fa-arrow-left me-2"></i>
                  Back
                </Button>
              </Col>
            </Row>
            <Row>
              <Col lg={6} className="mb-4 mb-lg-0">
                <h4 className="card-title mb-4">
                  {advertisement.name || "Advertisement Details"}
                </h4>
                <div className="media-container border p-3 rounded bg-light">
                  {renderMedia()}
                </div>

                <h5 className="mb-4 mt-2">
                  <i className="fas fa-receipt me-2"></i>
                  Payment Information
                </h5>

                <ListGroup flush>
                  <ListGroupItem className="d-flex justify-content-between align-items-center py-3">
                    <span className="fw-semibold">
                      <i className="fas fa-id-card me-2"></i>
                      Transaction ID:
                    </span>
                    <span className="text-muted">
                      {advPayment.transactionId}
                    </span>
                  </ListGroupItem>

                  <ListGroupItem className="d-flex justify-content-between align-items-center py-3">
                    <span className="fw-semibold">
                      <i className="fas fa-rupee-sign me-2"></i>
                      Amount:
                    </span>
                    <span className="text-muted">₹{advPayment.amount}</span>
                  </ListGroupItem>

                  <ListGroupItem className="d-flex justify-content-between align-items-center py-3">
                    <span className="fw-semibold">
                      <i className="far fa-calendar-alt me-2"></i>
                      Date:
                    </span>
                    <span className="text-muted">{advPayment.date}</span>
                  </ListGroupItem>

                  <ListGroupItem className="d-flex justify-content-between align-items-center py-3">
                    <span className="fw-semibold">
                      <i className="far fa-clock me-2"></i>
                      Time:
                    </span>
                    <span className="text-muted">{advPayment.time}</span>
                  </ListGroupItem>

                  <ListGroupItem className="d-flex justify-content-between align-items-center py-3">
                    <span className="fw-semibold">
                      <i className="fas fa-info-circle me-2"></i>
                      Status:
                    </span>
                    {renderPaymentStatusBadge()}
                  </ListGroupItem>
                </ListGroup>
              </Col>

              <Col lg={6}>
                <h5 className="mb-4">
                  <i className="fas fa-info-circle me-2"></i>
                  Advertisement Details
                </h5>

                <ListGroup flush>
                  <ListGroupItem className="d-flex justify-content-between align-items-center py-3">
                    <span className="fw-semibold">
                      <i className="fas fa-store me-2"></i>
                      Store Name:
                    </span>
                    <span className="text-muted">
                      {advertisement.storeName || "-"}
                    </span>
                  </ListGroupItem>

                  <ListGroupItem className="d-flex justify-content-between align-items-center py-3">
                    <span className="fw-semibold">
                      <i className="fas fa-ad me-2"></i>
                      Name:
                    </span>
                    <span className="text-muted">
                      {advertisement.name || "-"}
                    </span>
                  </ListGroupItem>

                  <ListGroupItem className="d-flex justify-content-between align-items-center py-3">
                    <span className="fw-semibold">
                      <i className="fas fa-tags me-2"></i>
                      Category:
                    </span>
                    <span className="text-muted">
                      {advertisement.advcategoryName || "-"}
                    </span>
                  </ListGroupItem>

                  <ListGroupItem className="d-flex justify-content-between align-items-center py-3">
                    <span className="fw-semibold">
                      <i className="fas fa-star me-2"></i>
                      Priority:
                    </span>
                    <span className="text-muted">
                      {advertisement.advpriority || "-"}
                    </span>
                  </ListGroupItem>

                  <ListGroupItem className="d-flex justify-content-between align-items-center py-3">
                    <span className="fw-semibold">
                      <i className="fas fa-money-bill-wave me-2"></i>
                      Price:
                    </span>
                    <span className="text-muted">
                      ₹{advertisement.advprice || "-"}
                    </span>
                  </ListGroupItem>

                  <ListGroupItem className="d-flex justify-content-between align-items-center py-3">
                    <span className="fw-semibold">
                      <i className="fas fa-image me-2"></i>
                      Media Type:
                    </span>
                    <span className="text-capitalize text-muted">
                      {advertisement.type || "-"}
                    </span>
                  </ListGroupItem>

                  <ListGroupItem className="d-flex justify-content-between align-items-center py-3">
                    <span className="fw-semibold">
                      <i className="fas fa-image me-2"></i>
                      Date:
                    </span>
                    <span className="text-capitalize text-muted">
                      {advertisement.fromDate || "-"} to{" "}
                      {advertisement.toDate || "-"}
                    </span>
                  </ListGroupItem>

                  <ListGroupItem className="d-flex justify-content-between align-items-center py-3">
                    <span className="fw-semibold">
                      <i className="fas fa-adjust me-2"></i>
                      Ad Type:
                    </span>
                    <span className="text-capitalize text-muted">
                      {advertisement.advtype || "-"}
                    </span>
                  </ListGroupItem>

                  <ListGroupItem className="d-flex justify-content-between align-items-center py-3">
                    <span className="fw-semibold">
                      <i className="fas fa-box me-2"></i>
                      Product:
                    </span>
                    <span className="text-capitalize text-muted">
                      {advertisement.productName || "-"}
                    </span>
                  </ListGroupItem>

                  <ListGroupItem className="py-3">
                    <div className="d-flex justify-content-between">
                      <span className="fw-semibold">
                        <i className="fas fa-city me-2"></i>
                        {advertisement.deltype || "-"}:
                      </span>
                      <div className="text-end">
                        {citiesList.length > 0 ? (
                          <div className="d-flex flex-wrap gap-2 justify-content-end">
                            {citiesList.map((city, index) => (
                              <Badge
                                key={index}
                                color="light"
                                className="text-dark"
                              >
                                {city}
                              </Badge>
                            ))}
                          </div>
                        ) : (
                          <span className="text-muted">-</span>
                        )}
                      </div>
                    </div>
                  </ListGroupItem>
                </ListGroup>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Container>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  )
}

export default ViewAdvertisements
